const l = {
  name: "AppStore",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M37,29.9l2.4,3.8c1.7,2.7-0.2,6.3-3.5,6.3h0c-1.4,0-2.7-0.7-3.5-1.9l0,0l-5-8.1H12.6l-5,8.1
			C6.8,39.3,5.5,40,4.1,40c-3.2,0-5.2-3.5-3.5-6.3l0,0L3,29.9c-1.7-0.4-3-2-3-3.9c0-1.1,0.5-2.1,1.2-2.8C1.9,22.5,2.9,22,4,22h3.9
			l7.2-11.5l-2.6-4.2C10.8,3.5,12.8,0,16,0c1.4,0,2.7,0.7,3.5,1.9l0,0L20,2.7l0.5-0.8C21.2,0.7,22.5,0,24,0c3.2,0,5.2,3.5,3.5,6.3
			l-2.6,4.2L32,22h4c2.2,0,4,1.8,4,4c0,1.1-0.5,2.1-1.2,2.8C38.3,29.3,37.7,29.7,37,29.9z M14.2,5.2L34.1,37l0,0
			c0.4,0.6,1.1,1,1.8,1h0c1.6,0,2.6-1.8,1.8-3.2l-3.3-5.3L29.7,22h0L18.8,4.6l0,0l-1-1.6c-0.4-0.6-1.1-1-1.8-1
			C14.4,2,13.4,3.8,14.2,5.2z M35.8,28H36c0.6,0,1.1-0.2,1.4-0.6c0.4-0.4,0.6-0.9,0.6-1.4c0-1.1-0.9-2-2-2h-2.7L35.8,28z M20,18.2
			L17.6,22h4.8L20,18.2z M5.3,30l-3,4.8C1.5,36.2,2.5,38,4.1,38c0.7,0,1.4-0.4,1.8-1l4.4-7H5.3z M23.6,8.6l2.1-3.4
			C26.6,3.8,25.6,2,24,2c-0.7,0-1.4,0.4-1.8,1l0,0l-1,1.6L23.6,8.6z M10.3,22h5l3.6-5.7l-2.5-4L10.3,22z M4,24
			c-0.6,0-1.1,0.2-1.4,0.6C2.2,24.9,2,25.4,2,26c0,1.1,0.9,2,2,2h22.1l-2.5-4H4z"/>
	</g>
</g>
</svg>
  `
};
export {
  l as AppStore
};
